export const MODIFIER_SEPARATOR = "_";
export const CSS_PREFIX = "sc";
